import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api"; // Ensure this path matches your API utility file

export const fetchEmployeeBankDetails = createAsyncThunk(
  "employee/fetchEmployeeBankDetails",
  async (searchText) => {
    const response = await api.post("/employee-bank-details",{ search: searchText });
    return response.data.data;
  }
);

export const addEmployeeBankDetails = createAsyncThunk(
    "employee/addEmployeeBankDetails",
    async ({ endpoint, bankDetails }, { dispatch, rejectWithValue }) => {
      try {
        const response = await api.post(endpoint, bankDetails);
        dispatch(fetchEmployeeBankDetails()); 
        return response.data.message; 
      } catch (error) {
        return rejectWithValue(
          error.response?.data.message || "Failed to save bank details"
        );
      }
    }
  );

export const deleteEmployeeBankDetails = createAsyncThunk(
  "employee/deleteEmployeeBankDetails",
  async (employeeId, { dispatch, rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("id", employeeId);
      const response = await api.post(
        `delete-employee-bank-details`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      dispatch(fetchEmployeeBankDetails());
      return response.data.message;
    } catch (error) {
      return rejectWithValue(
        error.response?.data.message || "Failed to delete user"
      );
    }
  }
);

// Define the initial state and slice
const employeeBankDetailSlice = createSlice({
  name: "employeeBankDetail",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    isAddModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
    addDataLoading: false,

  },
  reducers: {
    openEmployeeBankDetail: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeEmployeeBankDetail: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    openAddEmployeeBankDetail: (state) => {
      // New reducer to open Add modal
      state.isAddModalOpen = true;
    },
    closeAddEmployeeBankDetail: (state) => {
      // New reducer to close Add modal
      state.isAddModalOpen = false;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeBankDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeBankDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchEmployeeBankDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addEmployeeBankDetails.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addEmployeeBankDetails.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addEmployeeBankDetails.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteEmployeeBankDetails.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteEmployeeBankDetails.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteEmployeeBankDetails.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const {
  openEmployeeBankDetail,
  closeEmployeeBankDetail,
  openAddEmployeeBankDetail,
  closeAddEmployeeBankDetail,
  clearError,
} = employeeBankDetailSlice.actions;
export default employeeBankDetailSlice.reducer;
export { employeeBankDetailSlice };
